export enum WsEvent {
  Notification = 'Notification',
  Blockchain = 'Blockchain',
}
